import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { trackMixpanelPageView } from 'helpers/post';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Carousel from './Carousel';
import { GET_GO4_WORKED_JOBS } from 'redux/ducks/User';
import arrowSvg from './assets/circle-arrow-right-regular.svg';
import { brandsLogo, items } from 'scenes/V2/CreatePostScene/EventIntro/assets';
import { formatNumber } from 'helpers/dashboard';
import { get } from 'lodash';
import { GOOGLE_ADS_CLICK_IDENTIFIERS } from '@helpers/localStorage';
class EventIntro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: {
        active: false,
      },
    };
    this.brandsCarouselRef = React.createRef();
  }

  componentDidMount() {
    const { go4WorkedJobs } = this.props;
    if (!go4WorkedJobs.init && !go4WorkedJobs.workedJobs) {
      this.props.getGo4WorkedJobs();
    }

    if (this.brandsCarouselRef.current) {
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow(this.brandsCarouselRef));
      this.resizeObserver.observe(this.brandsCarouselRef.current);
    }

    const searchParams = get(this.props, 'location.search', '');
    if (searchParams) {
      localStorage.setItem(
        GOOGLE_ADS_CLICK_IDENTIFIERS,
        JSON.stringify({
          searchParams: searchParams,
          searchParamsSet: false,
        })
      );
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  checkOverflow = ref => {
    if (!ref.current) return false;

    this.setState(prevState => ({
      ...prevState,
      brands: {
        ...prevState.brands,
        active: this.brandsCarouselRef.current.scrollWidth > window.innerWidth,
      },
    }));

    return this.brandsCarouselRef.current.scrollWidth > window.innerWidth;
  };

  onImReady = () => {
    trackMixpanelPageView('ImReadyToPostClick', this.props.user);

    if (!this.props.authenticated) {
      this.props.history.push('/create-account/role');
      return;
    }

    this.props.history.push('type');
  };

  athleticTrainerSlides = () => {
    return items.map(slide => {
      return (
        <div className="embla__slide athletic__trainer" key={slide.name}>
          <img src={slide.image} alt={slide.name} className="at-profile-image" />
          <div className="embla__slide_info">
            <p className="at-name">{slide.name}</p>
            <p className="at-address-location">{slide.location}</p>
            <p className="at-worked-jobs">
              <span className="gotham-medium-font">{slide.workedJobs}</span> Jobs Worked
            </p>
          </div>
        </div>
      );
    });
  };

  institutionsLogoSlides = () => {
    return brandsLogo.map(image => {
      return (
        <div className="embla__slide brands" key={Math.floor(Math.random() * 1e9)}>
          <img
            src={image.imageUrl}
            alt={image.imageUrl}
            className="institution-logo"
            width={image.width}
            height={image.height}
            style={{
              objectFit: image.objectFit,
            }}
          />
        </div>
      );
    });
  };

  sendMixpanelEvent = () => {
    trackMixpanelPageView('intro_at_signup_link_clicked', this.props.user);
  };

  render() {
    const { go4WorkedJobs } = this.props;

    if (go4WorkedJobs.init) return null;

    return (
      <div className="eventIntro">
        <main className="content">
          <div className="content-wrapper">
            <div className="content-info">
              <div>
                <p className="go4-total-worked-jobs">{formatNumber(go4WorkedJobs.workedJobs)}+ JOBS WORKED</p>
                <h1 className="header">
                  <p>Welcome to the </p>
                  <p>largest network of </p>
                  <p>Athletic Trainers</p>
                </h1>
                <div className="advantage">
                  <img src={arrowSvg} alt="arrow-1" />
                  <p className="subheader">Hire local athletic trainers</p>
                </div>
                <div className="advantage">
                  <img src={arrowSvg} alt="arrow-2" />
                  <p className="subheader">
                    Credentials, insurance, and payment
                    <span className="long-line">&#9472;</span>handled for you
                  </p>
                </div>
                <div className="advantage">
                  <img src={arrowSvg} alt="arrow-3" />
                  <p className="subheader">Built-in risk management</p>
                </div>
              </div>

              <div className="ready-to-post">
                <Button className="ready-to-post-button" onClick={this.onImReady}>
                  Get Started
                </Button>
                <p>$0 until you hire</p>
              </div>

              <div className="athletic-trainer-link">
                <p>Are you an athletic trainer?</p>
                <a
                  href="https://www.go4.io/athletic-trainers/?account-modal=true"
                  target="_blank"
                  rel="noreferrer"
                  onClick={this.sendMixpanelEvent}
                >
                  {' '}
                  Sign up here
                </a>
              </div>
            </div>

            <div className="carousel-wrapper">
              <Carousel
                slides={this.athleticTrainerSlides()}
                containerClassName="athletic__trainer"
                viewportClassName="athletic__trainer"
                emblaClassName="athletic__trainer"
                options={{
                  dragFree: true,
                  align: 'start',
                  loop: false,
                  containScroll: 'trimSnap',
                }}
              />
            </div>
          </div>

          <div className="brands-container">
            <p>TRUSTED BY TOP INSTITUTIONS</p>
            <Carousel
              reference={this.brandsCarouselRef}
              slides={this.institutionsLogoSlides()}
              containerClassName="brands"
              viewportClassName="brands"
              emblaClassName="brands"
              options={{
                align: 'start',
                loop: true,
                containScroll: 'trimSnap',
                active: this.state.brands.active,
                watchFocus: false,
                watchDrag: false,
              }}
              autoScroll
              autoScrollOptions={{
                playOnInit: true,
                speed: 1.5,
                stopOnInteraction: true,
                stopOnFocusIn: false,
                startDelay: 500,
              }}
            />
          </div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.session.currentUser,
  authenticated: state.session.authenticated,
  go4WorkedJobs: state.user.go4WorkedJobs,
});

const mapDispatchToProps = dispatch => ({
  getGo4WorkedJobs: () => dispatch({ type: GET_GO4_WORKED_JOBS }),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventIntro));
